import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDCentralGovernmentBodyModel } from 'src/app/model/MDCentralGovernmentBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-central-government',
  templateUrl: './md-central-government.component.html',
  styleUrls: []
})
export class MDCentralGovernmentComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDCentralGovernmentBodyModel>();

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      nameAsOnCertificate: new FormControl(null, [Validators.required]),
      isStampReadable: new FormControl(null, [Validators.required]),
      isStampOfCompetentAuthority: new FormControl(null, [Validators.required]),
      isSignaturePresent: new FormControl(null, [Validators.required]),
      isRetirementDateWithinLimit: new FormControl(null, [Validators.required]),
      isStaffQuarterAllotted: new FormControl(null, [Validators.required]),
      isDateOfIssuePresent: new FormControl(null, [Validators.required]),
      // isQRCodePresent: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDCentralGovernmentBodyModel(
        this.verifyForm.value.nameAsOnCertificate,
        this.verifyForm.value.isStampReadable,
        this.verifyForm.value.isStampOfCompetentAuthority,
        this.verifyForm.value.isSignaturePresent,
        this.verifyForm.value.isRetirementDateWithinLimit,
        this.verifyForm.value.isStaffQuarterAllotted,
        this.verifyForm.value.isDateOfIssuePresent,
        // this.verifyForm.value.isQRCodePresent
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
